document.addEventListener("turbo:load", () => {
  const mapEl = document.querySelector("#world-map");
  if (mapEl && window.jsVectorMap) {
    new jsVectorMap({ selector: "#world-map", map: "world" });
  }
});
